let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("27NfI")).then(() => parcelRequire('l67DE'));